export const formatCurrency = (value: number | undefined | null): string => {
    if (value === undefined || value === null) return '$0.00';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
};

/**
 * Dinero para KPIs y celdas de tabla — SIN decimales.
 *
 * Usar esto en vez de `$${n.toLocaleString()}`: el default de toLocaleString es
 * maximumFractionDigits 3, así que 24086.2174 sale como "$24,086.217". Ese
 * tercer decimal rompe el ancho de la celda y desalinea toda la columna de
 * dinero — justo lo que la fuente tabular existía para evitar.
 */
export const money = (value: number | undefined | null): string => {
    if (value === undefined || value === null) return '$0';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
};

/**
 * Variación mes contra mes, con guarda de base.
 * Sobre una base diminuta el porcentaje se dispara ("+30033% vs Jul"), que no
 * informa nada y delata que nadie miró la pantalla con datos reales.
 * Devuelve null cuando no hay base suficiente para que la vista muestre texto
 * en vez de una cifra absurda.
 */
export const monthOverMonthPercent = (current: number, previous: number): number | null => {
    if (!previous || previous < 500) return null;
    const pct = ((current - previous) / previous) * 100;
    return Math.max(-999, Math.min(999, pct));
};
